<template>
  <div class="identity-wrap">
    <div class="choose-box">
      <h6 class="h6">请谨慎选择您的身份，提交后不可更改</h6>
      <van-row class="items" gutter="15">
        <van-col class="item" span="8" v-for="(item, index) in info" :key="index">
          <div class="wrap" :class="{ active: active == index + 1 }" @click="active = index + 1">
            {{ item.id == 1 ? '普通农户' : item.id == 2 ? '专业飞手' : '飞防组织' }}
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="p2" v-for="(item, index) in info" :key="index" v-show="index == active - 1">
      {{ item.content }}
    </div>
    <div class="btn-Submission" @click="sumbitIdentiy">提交</div>
  </div>
</template>
<script>
import axios from '../../http';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'identity',
  components: {},
  props: {},
  data() {
    return {
      active: 1,
      // token: this.$route.query.token,
      info: [],
    };
  },
  computed: {
    ...mapState(['token']),
    userType() {
      return this.active == 0 ? '普通农户' : this.active == 1 ? '专业飞手' : '飞防组织';
    },
  },
  watch: {},
  mounted() {
    let that = this;
    axios
      .fetchGet('/member/login/user_type_info')
      .then((res) => {
        this.info = res.data.data;
      })
      .catch((error) => {
        that.$toast(error.data.msg);
      });
  },
  destroyed() {},
  methods: {
    ...mapMutations(['getUserAvatar', 'getUserName', 'getUserPhone', 'getToken', 'setUserType']),
    sumbitIdentiy() {
      let that = this;
      axios
        .fetchPost('/member/login/choose_user_type', {
          token: that.token,
          user_type: that.active,
        })
        .then((res) => {
          let r = res.data;
          if (r.code == 200) {
            that.$toast(r.msg);
            that.getUserAvatar(res.data.data.avatar);
            that.getUserName(res.data.data.nickname);
            that.getUserPhone(res.data.data.mobile);
            that.getToken(res.data.data.token);
            that.setUserType(res.data.data.user_type);
            if (res.data.data.user_type == 1) {
              setTimeout(() => {
                this.$router.push({
                  path: '/secondBar/medication',
                });
              }, 500);
            } else if (res.data.data.user_type == 0) {
              setTimeout(() => {
                that.$router.push({
                  path: '/identity',
                  query: { token: res.data.data.token },
                });
              }, 500);
            } else {
              this.$router.replace({
                path: '/notFarmer',
              });
            }
          } else {
            that.$toast(r.msg);
          }
        })
        .catch((error) => {
          that.$toast(error.msg);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.identity-wrap
  height 100%
  overflow hidden
  .choose-box
    background #fff
    .h6
      height 45px
      line-height 45px
      color #989898
      font-size 14px
      padding-left 12px
      text-align left
      font-weight 400
      border-bottom 1px solid #e5e5e5
    .items
      padding 15px 12px
      .item
        height 40px
        line-height 40px
        .wrap
          border 1px solid #e5e5e5
          &.active
            border-color #FF9922
            color #FF9922
  .p2
    text-align left
    padding-left 12px
    padding-top 15px
    font-size 14px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(40, 40, 40, 1)
    line-height 1.1
  .btn-Submission
    position fixed
    left 12px
    right 12px
    height 40px
    line-height 40px
    text-align center
    background #FF9922
    font-size 17px
    bottom 10px
    color #fff
</style>
